module.exports = __webpack_public_path__ + "static/media/event_card_3.d389dc58.png";